// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class EstimateSellPrice {
  siemensMaterialSellPrice: number;
  outsideMaterialSellPrice: number;
  mechMaterialSellPrice: number;
  electMaterialSellPrice: number;
  siemensMaterialSHSellPrice: number;
  siemensMaterialWarrantySellPrice: number;
  outsideMaterialSHSellPrice: number;
  outsideMaterialWarrantySellPrice: number;
  mechMaterialSHSellPrice: number;
  mechMaterialWarrantySellPrice: number;
  elecMaterialSHSellPrice: number;
  elecMaterialWarrantySellPrice: number;
  pmSellPrice: number;
  engSellPrice: number;
  specSellPrice: number;
  mechSellPrice: number;
  elecSellPrice: number;
  progSellPrice: number;
  grapSellPrice: number;
  ddepSellPrice: number;
  miscSellPrice: number;
  travelSellPrice: number;
  riskCostSellPrice: number;
  autoRiskCostSellPrice: number;
  mechFeeCostSellPrice: number;
  subcontractorFeeCostSellPrice: number;
  productivityReserveSellPrice: number;
  cEngineeringSellPrice: number;
  qEngineeringSellPrice: number;
  nEngineeringSellPrice: number;
  eEngineeringSellPrice: number;
  lEngineeringSellPrice: number;
}
